import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AlertDialogService {

  constructor(private dialog: MatDialog) { }
  // tslint:disable-next-line: typedef
  openAlertDialog(messageText, buttonTextCancel = 'Kapat', solutionOfferText?){
    const dialogRef = this.dialog.open(AlertDialogComponent, { disableClose: true ,
      data: {
        message: messageText,
        solutionOffer: solutionOfferText,
        buttonText: {
          cancel: buttonTextCancel
        }
      },
    });
    return dialogRef;
  }
}
